<template lang="pug">
  .table-responsive
    table#tbSalidas.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th
            | #
          th 
            | Fecha Reg.
          th 
            | Usuario
          th 
            | Vehículo / Placa
          th 
            | Tarjeta
          th 
            | Carga Pesos
          th 
            | Carga Litros
          th 
            | Km. Actual
          th 
            | Ticket
      tbody
        tr(v-for="(salid, index) in salidas" :key="salid.id")
          td
            a.button.is-black.is-rounded.is-small(@click="eliminarSalida(salid)")
              i.fas.fa-trash
          td
            | {{ salid.fecha_salida }}
          td 
            | {{ salid.nombre_usuario }}
          td 
            | {{ salid.categoriaV }} {{ salid.subcategoriaV }} - {{ salid.placaV }}
          td 
            | {{ salid.tarjeta }}
          td
            | {{ salid.cargaPesos | currency }}
          td
            | {{ salid.cargaLitros }}
          td(v-if="salid.foto_km === ''")
            | {{ salid.km_actual }}&nbsp
            .field
              .file.is-small
                label.file-label
                  input.file-input(type='file' name='resume' @change="subirFotoKm($event, salid)" accept="image/*")
                  span.file-cta
                    span.file-icon
                      i.fas.fa-upload
                    span.file-label
                      i.fas.fa-camera
          td(v-else)
            | {{ salid.km_actual }}&nbsp
            a.button.is-black.is-rounded.is-small(:href="getRuta(salid.foto_km)" target="_blank")
              i.fas.fa-print
          td(v-if="salid.ticket === ''")
            .field
              .file.is-small
                label.file-label
                  input.file-input(type='file' name='resume' @change="subirTicket($event, salid)" accept="image/*")
                  span.file-cta
                    span.file-icon
                      i.fas.fa-upload
                    span.file-label
                      i.fas.fa-ticket-alt
          td(v-else)
            a.button.is-black.is-rounded.is-small(:href="getRuta(salid.ticket)" target="_blank")
              i.fas.fa-print
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
import InventarioServices from '../../../services/inventario/inventario'
  export default {
    name: 'Tb_salidas',
    props: {
      salidas: {
        type: Array,
        default: []
      },
      salidaSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    data() {
      return {
        hayDatos: false,
        itemsSelected: {},
        isDisabled: true
      }
    },
    watch: {
      salidas() {
        this.checkDatos()  
      },
      disabledItems() {
        this.isDisabled = this.disabledItems
      },
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = {}
        }
      },
      salidaSel () {
        this.itemsSelected = Object.assign({}, this.itemsSelected, this.salidaSel)
      }
      
    },
    methods: {
      iniciarComponente () {
        console.log(this.salidaSel)
        this.checkDatos()
      },
      checkDatos () {
        if (this.salidas.length > 0) {
          this.hayDatos = true
        } else {
          this.hayDatos = false
        }
      },
      subirTicket (e, salida) {
        InventarioServices.subirTicket(salida.id, e.target.files[0], e.target.files[0].name)
          .then((data) => {
            if (data.success) {
              this.displayToast('toasted-primary', 'Se ha subido el ticket a la base de datos.', 'done', 'OK')
              this.$emit('reloadTable', true)
            } else {
              this.displayToast('bubble',`Error: ${data.respuesta}.`, 'ban', 'OK')
            }
          })
          .catch((e) => {
            this.displayToast('bubble', e.message, 'ban', 'OK')
          })
      },
      subirFotoKm (e, salida) {
        InventarioServices.subirFotoKm(salida.id, e.target.files[0], e.target.files[0].name)
          .then((data) => {
            if (data.success) {
              this.displayToast('toasted-primary', 'Se ha subido el ticket a la base de datos.', 'done', 'OK')
              this.$emit('reloadTable', true)
            } else {
              this.displayToast('bubble',`Error: ${data.respuesta}.`, 'ban', 'OK')
            }
          })
          .catch((e) => {
            this.displayToast('bubble', e.message, 'ban', 'OK')
          })
      },
      eliminarSalida(salida) {
        this.$emit('eliminarSalida', salida)
      },
      getRuta(ruta) {
        const currentUrl = window.location.hostname
        return `https://${currentUrl}${ruta}`
      },
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/Tb_Salidas.vue